const r = {
  parts: ["popoverBody", "popoverContent"],
  baseStyle: ({ theme: o }) => ({
    popoverBody: {
      padding: o.box.paddingNull
    },
    popoverContent: {
      padding: o.box.paddingMd,
      fill: o.surface.accent1,
      borderColor: o.borderStyle.default.color,
      borderStyle: o.borderStyle.default.style,
      borderWidth: o.borderStyle.default.width,
      borderRadius: o.popoverBorderRadius,
      boxShadow: o.elevation.low,
      width: "100vw",
      "--popper-arrow-shadow-color": o.borderStyle.default.color
    }
  }),
  sizes: {
    extraSmall: ({ theme: o }) => ({
      popoverContent: {
        "max-width": o.popoverWidthExtraSmall
      }
    }),
    small: ({ theme: o }) => ({
      popoverContent: {
        "max-width": o.popoverWidthSmall
      }
    }),
    medium: ({ theme: o }) => ({
      popoverContent: {
        "max-width": o.popoverWidthMedium
      }
    }),
    large: ({ theme: o }) => ({
      popoverContent: {
        "max-width": o.popoverWidthLarge
      }
    })
  },
  defaultProps: {
    size: "small"
  }
};
export {
  r as default
};
